/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Statsnewin7days3Inputs */

const en_statsnewin7days3 = /** @type {(inputs: Statsnewin7days3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} in 7 days`)
};

const de_statsnewin7days3 = /** @type {(inputs: Statsnewin7days3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} in 7 Tagen`)
};

/**
* | output |
* | --- |
* | "+{count} in 7 days" |
*
* @param {Statsnewin7days3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsnewin7days3 = /** @type {((inputs: Statsnewin7days3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsnewin7days3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsnewin7days3(inputs)
	return de_statsnewin7days3(inputs)
});
export { statsnewin7days3 as "statsNewIn7Days" }